import "./App.css";
import Portada from "./components/portada/portada";
import Description from "./components/description/description";
import TextBanner from "./components/text-banner/text-banner";
// import Portfolio from "./components/portfolio/portfolio";

function App() {
  return (
    <>
      <Portada />
      <Description />
      <TextBanner />
      {/* <Portfolio /> */}
    </>
  );
}

export default App;
